module.exports = __webpack_public_path__ + "static/img/concrete_256.606c2c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/concrete_256.png
// module id = D1xR
// module chunks = 0